module.exports = __webpack_public_path__ + "static/media/page-header.ef733c38.jpg";